define('views/pages/trade/request/table',['require','jquery','underscore','views/base/collection','text!templates/pages/trade/request/table.ejs','views/pages/trade/request/table-row'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        CollectionView = require('views/base/collection'),
        templateTable = require('text!templates/pages/trade/request/table.ejs'),
        TradeRequestRowView = require('views/pages/trade/request/table-row');

    /*
        TRADE REQUEST TABLE
    */

    var TradeRequestTableView = CollectionView.extend({
        region: 'trade-request-table',
        autoRender: true,
        itemView: TradeRequestRowView,
        animationDuration: 0,
        template: templateTable,
        listSelector: 'tbody',
        // loadingSelector: '.loading',
        fallbackSelector: '.empty',
        listen: {
            'change:filterStatus_requested model': 'render',
            'change:filterStatus_processing model': 'render',
            'change:filterStatus_declined model': 'render',
            'change:filterStatus_check model': 'render',
            'change:filterStatus_ok model': 'render',
            'change:filterStatus_confirmed model': 'render',

            'change:filterType_om model': 'render',
            'change:filterType_on model': 'render',
            'change:filterType_fo model': 'render',
            'change:filterType_so model': 'render',

            'addedToDOM': 'onAddedToDOM',
            'change:loading model': 'onChangeLoading'
        },
        onChangeLoading: function() {
            var _this = this;
            _this.$('tbody')[({ true: 'addClass', false: 'removeClass' })[_this.model.get('loading')]]('preloader');

            // console.log('preloaders', _this.model.get('loading'));
        },
        filterer: function(item) {
            var valid = false, model = this.model;

            var type = model.get('filterType_' + item.get('type'));

            if (type) {
                var items = this.collection.where({ requestId: item.get('requestId') });

                valid = items.filter(function(itm) {
                    return model.get('filterStatus_' + itm.get('processed').status);
                }).length > 0;
            }

            // console.log(valid, model.getAttributes());

            return valid;
        },
        // filterCallback: function(view, included) {
        //     this.$el.stop(true, true);
        //     this.$el.css('display', included ? '' : 'none');
        // },
        onAddedToDOM: function() {
            _.each(this.getItemViews(), function(view) {
                view.bindEvents();
            });
            this.onResize();
        },
        render: function() {
            CollectionView.prototype.render.apply(this, arguments);

            if (document.body.contains(this.el)) {
                this.onAddedToDOM();
            }

            this.$('tbody').off('scroll').on('scroll', _.bind(function() { this.$('.trade-table-comment i').popover('destroy'); }, this));
        },
        onResize: function() {
            var h = $('body').height();
            var $b = this.$('tbody');
            h = h - $b.offset().top - 8;
            $b.css('height', h);
            // console.log('table resize', h);
        }
    });

    return TradeRequestTableView;
});

